<script lang="ts">
    import { Character, characterStore } from "../character/character";
import type {  WeaponType } from "./weapon";

    export let i: number;
    export let character: Character;
    export let weaponType: WeaponType;

    function swap(a: number, b: number) {
        const tmp = character.weapons[b].weaponType;

        character.weapons[b].weaponType = character.weapons[a].weaponType;
        character.weapons[a].weaponType = tmp;

        characterStore.set(character);
    }
</script>

<div
    class="
    float-left
    border border-gray-300 rounded-md 
    bg-gray-100
    p-1
    m-1
"
>
    {#if i < character.weapons.length - 1}
        <a
            class="hover:text-gray-400"
            on:change={() => characterStore.set(character)}
            on:click={() => swap(i + 1, i)}
        >
            ↓
        </a>
    {/if}

    {#if i > 0}
        <a
            class="hover:text-gray-400"
            on:change={() => characterStore.set(character)}
            on:click={() => swap(i - 1, i)}
        >
            ↑
        </a>
    {/if}

    {weaponType.name}
</div>
